import { Notification } from 'core/models/notification.model';
import { Role } from 'core/models/role.model';

/**
 * Referência fixa - dropdown do header (5 últimas notificações).
 */
export const MOCK_NOTIFICATIONS_DROPDOWN_REFERENCE: readonly Notification[] = [
  {
    id: 'notif-ref-001',
    userId: 'user-institucional',
    type: 'enrollment.confirmed',
    title: 'Matrícula confirmada',
    description: 'Matrícula No: 2026-0042 confirmada para a turma 6A.',
    iconClass: 'person-check',
    tone: 'success',
    actionUrl: '/enrollments/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T09:15:00.000Z',
  },
  {
    id: 'notif-ref-002',
    userId: 'user-institucional',
    title: 'Desconto disponível',
    description: 'Desconto disponível em mensalidades selecionadas.',
    iconClass: 'percent',
    tone: 'info',
    actionUrl: '/enrollments/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T08:40:00.000Z',
  },
  {
    id: 'notif-ref-003',
    userId: 'user-institucional',
    type: 'profile.updated',
    title: 'Conta verificada',
    description: 'Sua conta foi verificada com sucesso.',
    iconClass: 'patch-check',
    tone: 'success',
    actionUrl: '/profile',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T17:20:00.000Z',
  },
  {
    id: 'notif-ref-004',
    userId: 'user-institucional',
    type: 'enrollment.created',
    title: 'Matrícula registrada',
    description: 'Matrícula registrada com sucesso.',
    iconClass: 'check-circle',
    tone: 'success',
    highlight: 'Ana Souza - 6A',
    highlightTone: 'success',
    actionUrl: '/enrollments/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T14:05:00.000Z',
  },
  {
    id: 'notif-ref-005',
    userId: 'user-institucional',
    type: 'document.pending_validation',
    title: 'Documento pendente',
    description: 'Documento pendente de validação.',
    iconClass: 'clock-history',
    tone: 'warning',
    highlight: 'Pedro Lima - 7B',
    highlightTone: 'warning',
    actionUrl: '/school-documents',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T11:30:00.000Z',
  },
] as const;

const INSTITUTION_ADMIN_MOCKS: Notification[] = [
  ...MOCK_NOTIFICATIONS_DROPDOWN_REFERENCE.map((item) => ({ ...item })),
  {
    id: 'notif-006',
    userId: 'user-institucional',
    title: 'Comunicado publicado',
    description: 'Novo comunicado enviado para as turmas do ensino médio.',
    iconClass: 'megaphone',
    tone: 'info',
    actionUrl: '/classes/list',
    read: true,
    dismissed: false,
    createdAt: '2026-08-29T16:00:00.000Z',
  },
];

const TEACHER_MOCKS: Notification[] = [
  {
    id: 'notif-t-001',
    userId: 'user-professor',
    type: 'attendance.pending',
    title: 'Frequência pendente',
    description: 'Registro de frequência pendente para a turma 7B.',
    iconClass: 'clipboard-check',
    tone: 'warning',
    actionUrl: '/attendances',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T07:50:00.000Z',
  },
  {
    id: 'notif-t-002',
    userId: 'user-professor',
    type: 'grades.published',
    title: 'Nota lançada',
    description: 'Notas da avaliação bimestral foram publicadas.',
    iconClass: 'journal-check',
    tone: 'info',
    actionUrl: '/grades',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T19:10:00.000Z',
  },
  {
    id: 'notif-t-003',
    userId: 'user-professor',
    title: 'Reunião agendada',
    description: 'Conselho de classe agendado para sexta-feira.',
    iconClass: 'calendar-event',
    tone: 'info',
    actionUrl: '/class-diary',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T12:00:00.000Z',
  },
  {
    id: 'notif-t-004',
    userId: 'user-professor',
    type: 'class_teacher.assigned',
    title: 'Nova enturmação',
    description: 'Você foi alocado na turma 8A - Matemática.',
    iconClass: 'person-workspace',
    tone: 'info',
    actionUrl: '/class-teachers/list',
    read: true,
    dismissed: false,
    createdAt: '2026-08-29T10:00:00.000Z',
  },
];

const STUDENT_MOCKS: Notification[] = [
  {
    id: 'notif-s-001',
    userId: 'user-aluno',
    type: 'report_card.available',
    title: 'Boletim disponível',
    description: 'Seu boletim do 2º bimestre está disponível.',
    iconClass: 'file-earmark-text',
    tone: 'success',
    actionUrl: '/report-cards',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T10:00:00.000Z',
  },
  {
    id: 'notif-s-002',
    userId: 'user-aluno',
    type: 'enrollment.confirmed',
    title: 'Matrícula confirmada',
    description: 'Sua matrícula foi confirmada para a turma 6A.',
    iconClass: 'person-check',
    tone: 'success',
    actionUrl: '/classes/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T15:00:00.000Z',
  },
];

const GUARDIAN_MOCKS: Notification[] = [
  {
    id: 'notif-g-001',
    userId: 'user-responsavel',
    type: 'report_card.available',
    title: 'Boletim disponível',
    description: 'O boletim do 2º bimestre está disponível para consulta.',
    iconClass: 'file-earmark-text',
    tone: 'success',
    actionUrl: '/report-cards',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T10:00:00.000Z',
  },
  {
    id: 'notif-g-002',
    userId: 'user-responsavel',
    type: 'guardian_consent.pending',
    title: 'Consentimento pendente',
    description: 'Autorização pendente sobre os dados do aluno.',
    iconClass: 'shield-check',
    tone: 'warning',
    actionUrl: '/guardian-consents',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T14:00:00.000Z',
  },
  {
    id: 'notif-g-003',
    userId: 'user-responsavel',
    title: 'Desconto disponível',
    description: 'Desconto disponível em mensalidades selecionadas.',
    iconClass: 'percent',
    tone: 'info',
    actionUrl: '/enrollments/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-29T09:00:00.000Z',
  },
];

const SECRETARY_MOCKS: Notification[] = [
  {
    id: 'notif-sec-001',
    userId: 'user-secretaria',
    type: 'enrollment.created',
    title: 'Matrícula registrada',
    description: 'Nova matrícula registrada na turma 6A.',
    iconClass: 'check-circle',
    tone: 'success',
    actionUrl: '/enrollments/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T09:00:00.000Z',
  },
  {
    id: 'notif-sec-002',
    userId: 'user-secretaria',
    type: 'document.pending_validation',
    title: 'Documento pendente',
    description: 'Documento pendente de validação.',
    iconClass: 'clock-history',
    tone: 'warning',
    actionUrl: '/school-documents',
    read: false,
    dismissed: false,
    createdAt: '2026-08-30T11:00:00.000Z',
  },
];

const FINANCE_MOCKS: Notification[] = [
  {
    id: 'notif-fin-001',
    userId: 'user-financeiro',
    title: 'Desconto disponível',
    description: 'Desconto disponível em mensalidades selecionadas.',
    iconClass: 'percent',
    tone: 'info',
    actionUrl: '/enrollments/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T08:40:00.000Z',
  },
];

const PLATFORM_MOCKS: Notification[] = [
  {
    id: 'notif-plat-001',
    userId: 'user-plataforma',
    title: 'Nova instituição',
    description: 'Uma nova instituição foi cadastrada na plataforma.',
    iconClass: 'building',
    tone: 'info',
    actionUrl: '/institutions/list',
    read: false,
    dismissed: false,
    createdAt: '2026-08-31T08:00:00.000Z',
  },
];

/** Notificações de demonstração por perfil (mock auth). */
export const MOCK_NOTIFICATIONS_BY_ROLE: Record<Role, Notification[]> = {
  SUPER_ADMIN: PLATFORM_MOCKS,
  PLATFORM_ADMIN: PLATFORM_MOCKS,
  SUPPORT: [
    {
      id: 'notif-sup-001',
      userId: 'user-suporte',
      title: 'Solicitação de suporte',
      description: 'Nova solicitação de suporte aguardando atendimento.',
      iconClass: 'headset',
      tone: 'warning',
      actionUrl: '/institutions/list',
      read: false,
      dismissed: false,
      createdAt: '2026-08-31T07:00:00.000Z',
    },
  ],
  INSTITUTION_ADMIN: INSTITUTION_ADMIN_MOCKS,
  SECRETARY: SECRETARY_MOCKS,
  TEACHER: TEACHER_MOCKS,
  STUDENT: STUDENT_MOCKS,
  GUARDIAN: GUARDIAN_MOCKS,
  FINANCE: FINANCE_MOCKS,
  TRANSPORT_OPERATOR: [
    {
      id: 'notif-tr-001',
      userId: 'user-transporte',
      title: 'Rota atualizada',
      description: 'Alteração de rota de transporte escolar registrada.',
      iconClass: 'bus-front',
      tone: 'info',
      actionUrl: '/users/list',
      read: false,
      dismissed: false,
      createdAt: '2026-08-31T06:00:00.000Z',
    },
  ],
};

/** Dataset legado usado em testes locais. */
export const MOCK_NOTIFICATIONS: Notification[] = INSTITUTION_ADMIN_MOCKS;

export function mockNotificationsForRole(
  role: Role | null | undefined,
  userId: string,
): Notification[] {
  if (!role) {
    return [];
  }

  return (MOCK_NOTIFICATIONS_BY_ROLE[role] ?? []).map((item) => ({
    ...item,
    userId,
  }));
}
